import { styled } from "@mui/material";

export const LeftSection = styled('section')(({ theme }) => (props) => ({
    width: '30%',
    background: '#0056D21A',
    padding: '48px',
    paddingBottom: '20px',
    marginRight: '48px',
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('lg')]: {
        width: '35%'
    },
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))
export const ImgEdit = styled('img')(({ theme }) => ({
    marginTop: '10px',
}))